const PhlebType = Object.freeze({
  INSTALAB: 'instalab',
  GETLABS: 'getlabs',
  FACILITY: 'facility',
  QUEST: 'quest'
})

export default PhlebType